import { render, staticRenderFns } from "./showTab.vue?vue&type=template&id=3c5f43fe&"
import script from "./showTab.vue?vue&type=script&lang=js&"
export * from "./showTab.vue?vue&type=script&lang=js&"
import style0 from "./showTab.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports